/**
 * @generated SignedSource<<b0e1c3b771e728e662df9e94b27cf07c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersStoryStyleArticleListQuery$data = {
  readonly beauty: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly fashion: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly lifestyle: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly luxury: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly people: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle" | "storyStyleCardArticle">;
        };
      }>;
    } | null;
  } | null;
  readonly " $fragmentType": "helpersStoryStyleArticleListQuery";
};
export type helpersStoryStyleArticleListQuery$key = {
  readonly " $data"?: helpersStoryStyleArticleListQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersStoryStyleArticleListQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersStoryStyleArticleListQuery"
};

(node as any).hash = "1714c434beb531db5b25a22f3e251d5e";

export default node;
